<div class="chat-container">
  <app-social-chat-search></app-social-chat-search>
  @if (moderatedChat() && isUserHost()) {
    <div class="moderated-chat">
      <mat-tab-group
        mat-align-tabs="start"
        (selectedTabChange)="selectedTabChange($event)"
        disablePagination="true"
        mat-stretch-tabs="false"
      >
        <mat-tab label="Main"> </mat-tab>
        @if (hostChatSetting()) {
          <mat-tab label="Hosts"> </mat-tab>
        }
        @if (chatModerationSetting()) {
          <mat-tab label="Moderation Log">
            @if (showCountMessage()) {
              <ng-template mat-tab-label>
                <span class="count-span">{{ pendingMessageCount() }}</span> Moderation Log
              </ng-template>
            }
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  }

  <app-social-chat-feed
    #chatFeedComponent
    [moderatedChat]="moderatedChat()"
    [chatModerationSetting]="chatModerationSetting()"
    [hostChatSetting]="hostChatSetting()"
    [isUserHost]="isUserHost()"
    [tabSelected]="tabSelected()"
  ></app-social-chat-feed>
  @if (seesRaisedHands) {
    <app-qa-accept-raised-hands></app-qa-accept-raised-hands>
  }
  @if (!moderatedChat() || tabSelected() !== 'Moderation Log' || chatService.userIdToReply) {
    <app-social-chat-composer
      [moderatedChat]="moderatedChat()"
      [tabSelected]="tabSelected()"
      [replyUserId]="chatService.userIdToReply"
    ></app-social-chat-composer>
  }
  <app-qa-raise-hand></app-qa-raise-hand>
</div>
